export const activityReasonTypes = new Map([
  ['Education', 4],
  ['Check-in', 5],
  ['Chat', 6]
])

export const activityReasonCodes = new Map([
  [4, 'Education'],
  [5, 'Check-in'],
  [6, 'Chat']
])

export const activityTypes = new Map([
  ['System', 1],
  ['Manual', 2]
])

export const activityTypeCodes = new Map([
  [1, 'System'],
  [2, 'Manual']
])

export const activityLogBillingStatuses = new Map([
  [1, 'PENDING'],
  [2, 'BILLED']
])

export const activityLogBillingStatusesColors = new Map([
  [1, '#0000FF'],
  [2, '#008000']
])

export const ACTIVITY_LOG_DEFAULT_SORT = {
  sortedColumn: 'fullName',
  sortedColumnOrder: 'ascend'
}

export const ACTIVITY_LOG_ACTIVITES = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Billable Activity',
    value: 'billableActivity',
    color: 'var(--green)'
  },
  {
    title: 'Limited Activity',
    value: 'limitedActivity',
    color: 'var(--orange)'
  },
  {
    title: 'No Activity',
    value: 'noActivity',
    color: 'var(--scarlet)'
  }
]

export const NO_EP_ACTIVITY_LIST = [
  {
    label: 'No CCM activity',
    value: 'noCcmActivityDays'
  },
  {
    label: 'No RPM activity',
    value: 'noRpmActivityDays'
  },
  {
    label: 'No RTM Activity',
    value: 'noRtmActivityDays'
  },
  {
    label: 'No BHI Activity',
    value: 'noBhiActivityDays'
  },
  {
    label: 'No APCM Activity',
    value: 'noApcmActivityDays'
  },
  {
    label: 'No CCM/RPM/RTM/BHI/APCM activity',
    value: 'noCcmRpmRtmBhiApcmActivityDays'
  }
]

export const ACTIVITY_DASHBOARD_STATUSES_BY_NUMBERS = new Map([
  [
    0,
    {
      title: '-',
      className: '',
      value: 0
    }
  ],
  [
    1,
    {
      title: 'New',
      className: 'status-new',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'Pre-active',
      className: 'status-pre-active',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'Active',
      className: 'status-active',
      value: 3
    }
  ],
  [
    4,
    {
      title: 'On Hold',
      className: 'status-on-hold',
      value: 4
    }
  ],
  [
    5,
    {
      title: 'Discharged',
      className: 'status-discharged',
      value: 5
    }
  ]
])

export const ACTIVITY_DASHBOARD_STANDART_CCM_CODES = [
  {
    title: '99490/99439',
    value: '99490,99439'
  },
  {
    title: '99457/99458',
    value: '99457,99458'
  }
]

export const ACTIVITY_DASHBOARD_COMPLEX_CCM_CODES = [
  {
    title: '99487/99489',
    value: '99487,99489'
  }
]
